module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/fi-card-drag.5a5001ee8cfb8ee798b5.gif";